import {createApi} from '@reduxjs/toolkit/query/react';

import {createPriceReportBaseQuery} from './createPriceReportBaseQuery';

export const omneticToolsApi = createApi({
  reducerPath: 'omneticTools',
  baseQuery: createPriceReportBaseQuery({
    baseUrl: process.env.OMNETIC_TOOLS_API_URL,
  }),
  endpoints: (build) => ({
    getDownloadLink: build.mutation<{url: string}, {content: string; filename: string}>({
      query: (body) => ({
        url: '/html-to-pdf',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {useGetDownloadLinkMutation} = omneticToolsApi;
